import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { themesRepo } from "@/lib/repositories";
import { useDebounce } from "@/hooks/useDebounce";

export function useThemesSearch(initialSearch = "") {
  const [search, setSearch] = useState(initialSearch);
  const debouncedSearch = useDebounce(search, 300);

  const query = useQuery({
    queryKey: ["themes-search", debouncedSearch],
    queryFn: () =>
      themesRepo.fetchList({
        limit: 20,
        offset: 0,
        search: debouncedSearch || undefined,
        status: "active",
      }),
  });

  return {
    search,
    setSearch,
    themes: query.data?.results ?? [],
    isLoading: query.isLoading,
  };
}
